import { useCurrentStep } from './_atoms/draftReport/useCurrentStep';
import type { ReportStep } from './ReportSteps';

export const pathPrefix = '/reportProblem/';

export function getReportStepPath(step: ReportStep) {
	return `${pathPrefix}${step}`;
}

export function useDraftPath(step?: ReportStep) {
	const currentStep = useCurrentStep();

	const stepName = step ?? currentStep;
	if (!stepName) {
		return undefined;
	}

	return getReportStepPath(stepName);
}
